import React, { useState} from "react"
import {useTranslation} from "react-i18next"
import CommonUtils from "@bodeboca/utils"

const MobileFilters = () => {
  const {t} = useTranslation()
  function toggleTabs() {
    if (tabsIsOpen) {
    }
    setTabsIsOpen(!tabsIsOpen)
  }

  function toggleSort() {
    CommonUtils.toggleSort()
  }

  function toggleFilters() {
    CommonUtils.toggleFilters()
  }

  const [tabsIsOpen, setTabsIsOpen] = useState<boolean>(false)
  return (<div className={"filters-mobile filters-wrapper"}>
    <div
      className="bb-button bb-button-square bb-button-large bb-filter-tabs-toggle radio-canada-big"
      onClick={toggleTabs}>
      <span className="filter-text">
        {t("Filter")} / {t("Sort")}
      </span>
      <span className="icon bbicon-chevron-right"></span>
    </div>
    <div
      className={"tabs-wrapper " + (tabsIsOpen ? "tab-open" : "tab-closed")}>
      <div className="filter-tab">
        <a
          className="bb-filters-touch-toggle bb-button bb-button-square bb-button-large"
          onClick={toggleFilters}>
          {t("Filter")}
          <span className="filter-icon icon bbicon-chevron-right"></span>

        </a>
      </div>
      <div className="sort-tab onlymobile">
        <a
          className="bb-button bb-button-square bb-button-large"
          onClick={toggleSort}>
          {t("Sort")}
          <span className="sort-icon icon bbicon-chevron-right"></span>
        </a>
      </div>
      <div className="clear"></div>
    </div>
  </div>)
}
export default MobileFilters
